import { createContext, useContext, useState } from "react";
import { FormService, useFormService } from "../api/api-hooks/useFormService";
import {
    TemplateService,
    useTemplateService
} from "../api/api-hooks/useTemplateService";
import {
    HtmlToPdfBase64Service,
    useHtmlToPdfBase64Service
} from "../api/api-hooks/useHtmlToPdfBase64Service";
import {
    MunicipalityService,
    useMunicipalityService
} from "../api/api-hooks/useMunicipalityService";
import {
    StatisticsService,
    useStatisticsService
} from "../api/api-hooks/useStatisticService";

interface ServiceContextProps {
    formService: FormService;
    templateService: TemplateService;
    htmlToPdfService: HtmlToPdfBase64Service;
    municipalityService: MunicipalityService;
    statisticsService: StatisticsService;
}

const ServiceContext = createContext<ServiceContextProps | undefined>(
    undefined
);

interface ServiceProviderProps {
    children: React.ReactNode;
}

export function ServiceProvider({
    children
}: ServiceProviderProps): React.ReactElement {
    const [formService] = useState<FormService>(useFormService());
    const [templateService] = useState<TemplateService>(useTemplateService());
    const [municipalityService] = useState<MunicipalityService>(
        useMunicipalityService()
    );
    const [htmlToPdfService] = useState<HtmlToPdfBase64Service>(
        useHtmlToPdfBase64Service()
    );

    const [statisticsService] = useState<StatisticsService>(
        useStatisticsService()
    );

    return (
        <ServiceContext.Provider
            value={{
                formService,
                templateService,
                htmlToPdfService,
                municipalityService,
                statisticsService
            }}
        >
            {children}
        </ServiceContext.Provider>
    );
}

export function useServiceContext(): ServiceContextProps {
    const context = useContext(ServiceContext);
    if (context === undefined) {
        throw new Error(
            "useServiceContext must be used within a ServiceProvider"
        );
    }
    return context;
}
